import { LitheElement, LitheFC } from '@wheelbox/lithejs-engine';

import { createId, clsx } from '../../../utils/';

import { withSlice } from '../../../state';
import { APP_GLOBAL_SLICE } from '../../../constants/app';
import { GlobalSlice } from '../../../state/index.model';

type CardProps = { classes?: string[] | string };

const Card: LitheFC<CardProps> = (
  { id = createId(), testId = 'card', classes },
  ...children
): LitheElement<'div'> => {
  const state = withSlice<GlobalSlice>(APP_GLOBAL_SLICE);

  return [
    'div',
    {
      id,
      'data-testid': testId,
      class: [
        'p-4 shadow-md',
        state.theme === 'dark'
          ? 'bg-dark-background text-dark-text border border-dark-text'
          : 'bg-white',
        ...clsx(classes),
      ],
    },
    ...children,
  ];
};

export default Card;
